<template>
  <div
    v-if="filteredExistence.length > 0"
    class="main-pcLogisticExistenceBatch"
  >
    <f7-list
      v-for="(almacen, i) in filteredExistence"
      :key="i"
      class="content-logistic-list"
      accordion-list
      accordion-opposite
    >
      <f7-list-item
        class="content-logistic-list-item"
        :opened="true"
        :accordion-item-opened="i === (filteredExistence.length - 1)"
        accordion-item
        :title="almacen.NombreAgrupacion"
      >
        <template #after>
          <img
            src="@/static/icons/ic_deleteGris.svg"
            width="30px"
            @click="DeleteExistence(almacen)"
          >
        </template>
        <f7-accordion-content
          v-for="(partidas, j) in almacen.Partidas"
          :key="j"
          class="content-logistic-batch-list-item__accordion-content"
        >
          <div class="content-logistic-batch-list-item__accordion-content--component">
            <UCAcordeon
              :items="[partidas.Partida]"
              title-option="NombreLista"
              class="mainAcordeon-merchandise-batch-movements mainAcordeon"
              :show-checkbox="false"
              :show-badge="false"
              font-color="var(--his-dark-blue)"
              primary="var(--his-silver)"
              :closed="true"
              :opened-index="0"
              :after-title="false"
              :search-with-checkbox="false"
            >
              <template #subOptionSubtitle="{ item }">
                <f7-list
                  media-list
                >
                  <f7-list-item
                    checkbox
                    link="#"
                    class="content-logistic-batch-acordeon-list"
                    :checked="item.checked"
                    @click="SelectItem(item)"
                  >
                    <template #root-start>
                      <span class="content-logistic-batch-acordeon-list__span background-blue">
                        {{ `${$t('common.stocks').toUpperCase()}: ${item.CantidadFinal} ${$t('common.of')} ${item.CantidadTotal}` }}
                      </span>
                    </template>

                    <template #title>
                      <div class="span-title ">
                        {{ item.Articulo.Nombre }}
                      </div>
                    </template>

                    <div class="item-subtitle">
                      {{ item.Articulo.Codigo }}
                    </div>

                    <template #after>
                      <div>
                        <img
                          class="btnOptions"
                          src="@/static/icons/ic_options_blue_background.svg"
                          width="27"
                          @click="SelectMerchadise(item.Articulo.Id, item.Partida.Id, item.Almacen.Id)"
                        >
                        <img
                          class="btnNext"
                          src="@/static/icons/ic_arrow_blue.svg"
                          width="27"
                          @click="OpenActionBatch(item)"
                        >
                      </div>
                    </template>
                  </f7-list-item>
                </f7-list>
              </template>
            </UCAcordeon>
          </div>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>

    <PCLogisticExistenceLocation
      ref="PCLogisticExistenceLocationPopup"
      :existencias="accumulatedForLocation"
      @change-value="ChangeQuantityItem"
      @popup:closed="showLocationComponent = false"
    />

    <f7-actions
      class="logistic-existence-item-actions-sheet"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <div
          v-if="accumulatedStockSelected.length > 0"
          class="content-action-sheet-logistic-existence--items text-align-center"
        >
          <span class="content-action-sheet-logistic-existence--items__title">
            {{ $t('production.common.enterQuantity') }}
          </span>
          <f7-stepper
            :key="accumulatedStockSelected[0].Id"
            fill
            class="content-action-sheet-logistic-existence--items__stepper"
            :min="0"
            :max="accumulatedStockSelected.reduce((total, item) => total + item.CantidadTotal, 0)"
            :manual-input-mode="true"
            :value="accumulatedStockSelected.reduce((total, item) => total + item.CantidadFinal, 0)"
            @input="valorInputCantidad = $event.target.value"
          />
        </div>
        <div class="content-action-sheet-logistic-existence--items__buttons">
          <f7-button
            class="content-action-sheet-logistic-existence--items__buttons--cancel"
            @click="actionChangesOpened = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </f7-button>
          <f7-button
            class="content-action-sheet-logistic-existence--items__buttons--confirm"
            @click="ChangeValueStepper(); actionChangesOpened = false"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </f7-button>
        </div>
      </f7-block>
    </f7-actions>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { Log } from '@/js/common/HIDebuggingSupport';
import { PreloaderGH } from '@/js/common/HINotificationSupport';

import { useWarehouseStore } from '@/js/stores/warehouse';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import PCLogisticExistenceLocation from './PCLogisticExistenceLocation.vue';

export default defineComponent({
  name: 'PCLogisticExistenceBatch',

  components: {
    UCAcordeon,
    PCLogisticExistenceLocation,
  },

  data() {
    return {
      actionChangesOpened: false,
      valorInputCantidad: 0,
      dataAccordeon: [],
      selectedItem: [],
      selectedItemForLocation: [],
      showLocationComponent: false,
    };
  },
  computed: {
    accumulatedStockSelected() {
      return this.selectedItem ?? [];
    },

    accumulatedForLocation() {
      return this.selectedItemForLocation ?? [];
    },

    filteredExistence() {
      return this.dataAccordeon.length > 0 ? this.dataAccordeon : [];
    },

    ...mapState(useWarehouseStore, [
      'listaExistenciasMovMerc',
    ]),
    ...mapWritableState(useWarehouseStore, ['listaExistenciasMovMerc']),
  },

  watch: {
    listaExistenciasMovMerc(val) {
      if (val && val.length > 0) {
        this.FilterData();
      }
    },
  },

  methods: {
    ChangeQuantityItem() {
      Log(this, this.ChangeQuantityItem.name);
      this.FilterData();
    },

    DeleteExistence(existencia) {
      Log(this, this.DeleteExistence.name);
      this.dataAccordeon = this.dataAccordeon.filter((f) => f.AlmacenId !== existencia.AlmacenId);

      this.listaExistenciasMovMerc = this.listaExistenciasMovMerc.filter((f) => f.Almacen.Id !== existencia.AlmacenId);
    },

    OpenActionBatch(value) {
      Log(this, this.OpenActionBatch.name);
      this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

      this.actionChangesOpened = true;
    },

    SelectMerchadise(articulo, partida, almacen) {
      Log(this, this.SelectMerchadise.name);
      this.selectedItemForLocation = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === articulo && f.Partida.Id === partida && f.Almacen.Id === almacen);
      this.showLocationComponent = true;

      this.$refs.PCLogisticExistenceLocationPopup.OpenPopup();
    },

    SelectItem(value) {
      Log(this, this.SelectItem.name);

      if (!this.showLocationComponent && !this.actionChangesOpened) {
        this.selectedItem = this.listaExistenciasMovMerc.filter((f) => f.Articulo.Id === value.Articulo.Id && f.Partida.Id === value.Partida.Id && f.Almacen.Id === value.Almacen.Id);

        value.checked = !value.checked;
        this.UpdateCantidadFinal(value);
        if (value.checked) {
          value.CantidadFinal += value.CantidadTotal;
        }
        this.valorInputCantidad = value.CantidadFinal;
        this.AjustarAcumulados();
      }
    },

    ChangeValueStepper() {
      Log(this, this.ChangeValueStepper.name);
      this.AjustarAcumulados();

      this.FilterData();
    },

    AjustarAcumulados() {
      Log(this, this.AjustarAcumulados.name);
      let sumaActual = 0;
      const acumuladosSeleccionados = [];

      for (let i = 0; i < this.accumulatedStockSelected.length; i += 1) {
        const acumulado = this.accumulatedStockSelected[i];
        const cantidadDisponible = acumulado.Cantidad;
        acumulado.Seleccion = 0;

        if (sumaActual + cantidadDisponible <= this.valorInputCantidad) {
          acumulado.Seleccion = cantidadDisponible;
          acumuladosSeleccionados.push(acumulado);
          sumaActual += cantidadDisponible;
        } else {
          // Si con este acumulado se excede el valorInputCantidad, ajustar la cantidad
          const cantidadNecesaria = this.valorInputCantidad - sumaActual;
          if (cantidadNecesaria > 0) {
            acumulado.Seleccion = cantidadNecesaria;
            acumuladosSeleccionados.push(acumulado);
            // sumaActual += cantidadNecesaria;
          }
          break; // Ya hemos alcanzado la cantidad solicitada
        }
      }
      acumuladosSeleccionados.forEach((acumulado) => {
        const existencia = this.listaExistenciasMovMerc.find((f) => f.Id === acumulado.Id);
        existencia.Seleccion = acumulado.Seleccion;
        existencia.checked = existencia.Seleccion > 0;
      });
    },

    UpdateCantidadFinal(item) {
      Log(this, this.UpdateCantidadFinal.name);
      // if (Object.hasOwn(item, 'CantidadFinal') && Object.hasOwn(item, 'CantidadTotal')) return;

      if (!Object.hasOwn(item, 'CantidadFinal')) {
        item.CantidadFinal = 0;
      }
      if (!Object.hasOwn(item, 'CantidadTotal')) {
        item.CantidadTotal = item.Cantidad;
      }

      if (!Object.hasOwn(item, 'Seleccion')) {
        item.Seleccion = item.CantidadFinal;
      }

      if (!item.checked) {
        item.Seleccion = 0;
        item.CantidadFinal = 0;
      }

      if (Number.isInteger(item.CantidadFinal)) {
        Number(item.CantidadFinal);
      } else {
        item.CantidadFinal = Number.parseFloat(item.CantidadFinal.toFixed(2));
      }
    },

    CreatePartidaObject(idPartida, item) {
      Log(this, this.CreatePartidaObject.name);
      const partida = `${this.$t('common.batch')}: ${item.Partida.Serie}/${item.Partida.Numero}`;
      return {
        [partida]: {
          Partida: { NombreLista: partida, IdPartida: idPartida, items: [item] },
        },
      };
    },

    FilterData() {
      Log(this, this.FilterData.name);
      PreloaderGH(true, true, this.$t('common.loadingData'), '');
      const resultado = [];
      const idsAlmacen = new Set();
      const numeroSerieBatch = (partida) => `${this.$t('common.batch')}: ${partida.Serie}/${partida.Numero}`;

      // const listaExistenciasMovMercCopy = [...this.listaExistenciasMovMerc];
      this.listaExistenciasMovMerc.forEach((existencia) => {
        this.UpdateCantidadFinal(existencia);

        const e = { ...existencia };
        if (!e.UnidadContenedora) {
          const { Id: idAlmacen, Nombre: nombreAlmacen } = e.Almacen;
          const { Id: idPartida } = e.Partida;
          const { Id: idItem } = e.Articulo;

          idsAlmacen.add(idAlmacen);

          const contenedoraIndex = resultado.findIndex((r) => r.AlmacenId === idAlmacen);

          if (contenedoraIndex === -1) {
            e.CantidadFinal = e.Seleccion;

            resultado.push({
              AlmacenId: idAlmacen,
              NombreAgrupacion: nombreAlmacen,
              Partidas: this.CreatePartidaObject(idPartida, e),
            });
          } else {
            const partidaObject = resultado[contenedoraIndex].Partidas;
            const partidaKey = numeroSerieBatch(e.Partida);

            if (!partidaObject[partidaKey]) {
              Object.assign(partidaObject, this.CreatePartidaObject(idPartida, e));
            } else {
              const itemsArray = partidaObject[partidaKey].Partida.items;
              const indexItem = itemsArray.findIndex((i) => i.Articulo.Id === idItem);

              if (indexItem === -1) {
                itemsArray.push(e);
              } else {
                this.UpdateCantidadFinal(itemsArray[indexItem]);

                itemsArray[indexItem].CantidadFinal += e.Seleccion;
                itemsArray[indexItem].CantidadTotal += e.Cantidad;
                // itemsArray[indexItem].Cantidad = itemsArray[indexItem].CantidadTotal;

                if (Number.isInteger(itemsArray[indexItem].CantidadTotal)) {
                  Number(itemsArray[indexItem].CantidadTotal);
                } else {
                  itemsArray[indexItem].CantidadTotal = Number.parseFloat(itemsArray[indexItem].CantidadTotal.toFixed(2));
                }
              }
            }
          }
        }
      });

      this.dataAccordeon = resultado;
      PreloaderGH(false);
    },
  },
});
</script>

<style lang="scss">
.main-pcLogisticExistenceBatch {
  background: white;

  .accordion-item > .item-link {
    background-color: var(--his-slate-blue);
    --f7-list-chevron-icon-color: #fff;
    --f7-list-item-title-font-weight: 600;

    .item-content .item-inner .item-title {
      color: white;
      font-weight: 500;
    }
  }

  .storybook-action-sorted-accordion .accordion-list .sorted-accordion {
    .accordion-item-content .search-list .item-content {
      padding-left: 0;

      .item-checkbox > .icon-checkbox {
        margin-right: 8px;
      }
    }
  }

  .mainAcordeon-merchandise-batch-movements {
    .accordion-list .accordion-item .item-inner .item-link .item-title {
      font-weight: 500;
    }

    .content-logistic-batch-acordeon-list {
      .item-link {
        .item-content {
          .item-inner {
            padding-right: 10px;

            .item-title-row {
              padding-right: 2px;

              .item-after {
                .btnNext {
                  margin-left: 10px;
                  -webkit-filter: none;
                }
              }
            }
          }
        }
      }
    }

    .content-logistic-batch-acordeon-list__span {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      border-radius: 5px;
      padding: 2px 0;
    }

    .span-title {
      font-size: 17px;
      padding-top: 10px;
      font-weight: 600;
      color: var(--his-slate-blue);
    }

    .background-blue {
      background: var(--his-blueberry-mist);
      color: var(--his-slate-blue);
    }

    .background-green {
      background: var(--his-melon-tint);
      color: var(--his-greenlight);
    }

    .background-red {
      background: var(--his-tomate-tint);
      color: var(--his-tomate);
    }
  }
}

.logistic-existence-item-actions-sheet {
  background-color: #fff;

  .content-action-sheet-logistic-existence {
    &--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 60px;

      &__title {
        font-size: 18px;
        font-weight: 400;
        padding-bottom: 24px;
        color: var(--his-steel-blue);
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &--cancel {
          color: var(--his-darkgray);
          border: 1px solid var(--his-darkgray);
          background-color: var(--his-bg);
        }

        &--confirm {
          background-color: var(--his-dark-blue);
          color: #fff;
        }
      }

      &__stepper {
        --f7-stepper-fill-button-text-color: #fff;
        --f7-stepper-height: 36px;
        --f7-stepper-border-radius: 0px;

        .stepper-input-wrap {
          input {
            width: 100px;
            border: none;
          }
        }

        .actions-label::after {
          height: 0 !important;
        }
      }
    }
  }
}
</style>
